import React from 'react';

import {
  ReactComponent as AddIcon,
} from '../../../assets/petDemos/add-icon.svg';
import { ReactComponent as CatIcon } from '../../../assets/petDemos/cat.svg';
import { ReactComponent as DogIcon } from '../../../assets/petDemos/dog.svg';
import {
  ReactComponent as CheckIcon,
} from '../../../assets/check-onyx.svg';

import { PET_DEMOS_SPECIES } from '../../../constants';

import styles from './PetItem.module.css';

const SPECIE_ICON_COMPONENT = {
  [PET_DEMOS_SPECIES.cat]: CatIcon,
  [PET_DEMOS_SPECIES.dog]: DogIcon,
};

const SPECIE_KEY = {
  [PET_DEMOS_SPECIES.cat]: PET_DEMOS_SPECIES.cat,
  [PET_DEMOS_SPECIES.dog]: PET_DEMOS_SPECIES.dog,
};

const PetItem = ({
  className = '',
  disabled = false,
  iconClassName = '',
  isIneligible = false,
  isRemoved = false,
  isRollover = false,
  isRolloverModal = false,
  isSelected = false,
  label = '',
  onClick = () => { },
  specie = PET_DEMOS_SPECIES.dog,
}) => {
  const specieKey = SPECIE_KEY[specie] || SPECIE_KEY[PET_DEMOS_SPECIES.dog];
  const IconComponent = SPECIE_ICON_COMPONENT[specie]
    || SPECIE_ICON_COMPONENT[PET_DEMOS_SPECIES.dog];

  const PetItemContent = () => (
    <>
      <IconComponent
        aria-label={`${specieKey} ${label}`}
        className={`${styles.icon} ${iconClassName}`}
        data-is-rollover-modal={isRolloverModal}
        data-rollover={isRollover}
        data-specie={specieKey}
      />

      <span
        className={styles.label}
        data-is-rollover-modal={isRolloverModal}
        data-removed={isRemoved}
        data-rollover={isRollover}
      >
        {label || '...'}
      </span>
    </>
  );

  if (isRolloverModal) {
    const rolloverModalIcon = isSelected ? (
      <CheckIcon className={styles.check} />
    ) : (
      <AddIcon />
    );

    return (
      <button
        className={`${styles.petItemRolloverModal} ${className}`}
        data-is-rollover-modal={isRolloverModal}
        data-is-selected={isSelected}
        disabled={disabled}
        onClick={onClick}
        type="button"
      >
        <PetItemContent />

        {rolloverModalIcon}
      </button>
    );
  }

  // PetItem for CoveragePetsSection
  const displayCheckIcon = !isRemoved
    && !isIneligible
    && label
    && !isRollover;

  return (
    <span
      className={`${styles.petItem} ${className}`}
      data-removed={isRemoved}
      data-rollover={isRollover}
    >
      <PetItemContent />

      {displayCheckIcon && (
        <CheckIcon className={styles.check} />
      )}
    </span>
  );
};

export { PetItem };
